import React, { useEffect, useRef, useState } from "react";
import { Container } from "../../../components/Container/Containers";
import { Formik, Field, Form, useField, ErrorMessage,useFormikContext } from 'formik';
import DropDown from "../../../components/dropDown/DropDown";
import { DIAMETER, SIGTRAN, TRANSPORT, DNS, SERVICE_REQUEST_OPTIONS, GRX, VOLTE, columnConfig, MY_SERVICE_TABS, ALLOWED_IPX_LIVE_SERVICES } from "../../../utils/constants/serviceConstants";
import Section from "../../../components/Section/Section"
import MultiDropDown from "../../../components/dropDown/MultiDropDown";
import styles from "./newService.module.css";
import {
  FormFieldLabel as Label,
  FormErrorLabel as ErrorLabel,
} from "../../../components/label/Labels";
import { useNavigate } from "react-router-dom";
import { FormTextArea, TextInput } from "../../../components/input/inputs";
import * as Yup from "yup";
import { app } from '../../../configuration/gcp-identity-platform-config';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Submit, BackButton } from "../../../components/button/buttons";
// import { Alert } from "../../../components/alert/alerts";
import success from '../../../assets/images/success.png';
import Asterisk from "../../../components/asterisk/Asterisk";
import { USER_TYPE } from "../../../utils/constants/userConstants";
import FileAttachment from "../../../components/fileAttachment/fileAttachment.container";
import CAN from '../../../casl/can';
import { Action, Resource } from '../../../casl/constants';
import { Sidebar } from "../../../components/sidebar/Sidebar";
import IMAGES from "../../../assets/images/images";
import * as DOMPurify from 'dompurify';
import { RadioTabs } from "../../../components/tabs/RadioTabs";
import { Loader } from "../../../components/loader/Loader";
import SectionGuard from "../../../hoc/guards/SectionGuard";
import Table from "../../../components/table/Table";
import FileUploadAttachment from "../../../components/fileUpload/fileUpload.container";
import { getLogo } from "../../../utils/constants/fileTypeLogo";
import {getLocationDetails, sortByLabelAsc } from "../../../utils/arrayUtils";

let dropObj = {
  width: "auto"
}
const filterIPXLiveServicesForAmend=(data)=>{
  const filtered = data.filter(item => {
    const service = item?.value?.split('-')[0]?.toLowerCase();
   const city=item?.value?.split('-')?.[1]
    return ALLOWED_IPX_LIVE_SERVICES.includes(service?.trim()) && city && city != 'undefined' && city != undefined
  });
 return filtered
}
const FieldWrapper = ({ children }) => {
  return <div className={styles.fieldContainer}>{children}</div>;
};

const SelectField = ({ title, options, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  return (
    <FieldWrapper>
      <div>
        <Label text={title} /><Asterisk />
      </div>
      <DropDown
        options={options}
        onChange={({ label, value }) => {
          props.onChange(value);
          helpers.setValue(value);
        }}
        value={
          ((options?.length > 0) && field.value)
            ? options.find((option) => option.value === field.value)
            : ""
        }
        hasError={hasError}
        isDisabled={props.isDisabled}
        customStyles={dropObj}
      />
      {hasError ? <ErrorLabel text={meta.error} /> : null}
    </FieldWrapper>
  );
};

const TextField = ({ label, disabled, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  const inputStyle = hasError
    ? `${styles.input} ${styles.inputError}`
    : styles.input;
  return (
    <FieldWrapper>
      <div>
        <Label text={label} /><Asterisk />
      </div>
      <TextInput {...field} {...props} style={inputStyle} disabled={disabled} />
      {hasError ? <ErrorLabel text={meta.error} /> : null}
    </FieldWrapper>
  );
};

const CustomSearchInput = ({ label, suggestions = [], onValueChange, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error;
  const inputStyle = hasError ? `${styles.input} ${styles.inputError}` : styles.input;
  const { setFieldValue } = useFormikContext();
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [isRPFromSuggestions, setIsFromSuggestions] = useState(false);


  const handleInputChange = (e) => {
    const value = e.target.value?.trim().toUpperCase() || "";
    setFieldValue(field.name, value); // Update Formik field value

     setFilteredSuggestions(
      suggestions.filter((item) =>
        item?.tadigId?.toLowerCase().includes(value?.toLowerCase())
      )
    );
    setIsFromSuggestions(false); // Mark as custom value
    if (onValueChange) {
      onValueChange(value, false); // Return value and 'new' flag
    }
  };

  const handleSuggestionClick = (item) => {
    setFieldValue(field.name, item.tadigId); // Assign selected suggestion
    setFilteredSuggestions([]); // Hide suggestions
    setIsFromSuggestions(true); // Mark as from suggestions
    if (onValueChange) {
      onValueChange(item, true); // Return value and 'from suggestions' flag
    }
  };

  return (
    <FieldWrapper>

      <div>
        <Label text={label} /><Asterisk />
      </div>
       <div className={styles.parent}>
        <TextInput {...field} {...props} style={inputStyle}  onChange={handleInputChange}/>
        <img className={styles.serchicon} src={IMAGES.searchicon} alt="" />
      </div>
      {hasError && <ErrorLabel text={meta.error} />}     
      { filteredSuggestions.length>0 && (
        <div><div className={styles.tablemain}>
          <table className={styles.table}>
            <thead className={styles.thead}>
              <tr className={styles.tr}>
                <th className={styles.th}>TADIG Code</th>
                <th className={styles.th}>Operator Name</th>
                <th className={styles.th}>Country</th>
              </tr>
            </thead>
            <tbody className={styles.tbody}>
              {filteredSuggestions?.map((item, index) => (
                <tr className={styles.tr} key={index} onClick={() => handleSuggestionClick(item)}>
                  <td className={styles.td}>{item.tadigId}</td>
                  <td className={styles.td}>{item.roamingPartnerName}</td>
                  <td className={styles.td}>{item.country}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div></div>)
    }
     </FieldWrapper>
  );
};



const TextArea = ({ label, optional = false,maxlength, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  const inputStyle = hasError
    ? `${styles.input} ${styles.inputError}`
    : styles.input;
  return (
    <FieldWrapper>
      <Label text={label} optional={optional} />
      <FormTextArea {...field} {...props} style={inputStyle} />
       <div style={{display:"flex", justifyContent: hasError?"space-between":"flex-end"}}>
         {hasError ? <ErrorLabel text={meta.error} /> : null}   
         {maxlength ?? <label >{maxlength}</label>}
       </div>
    </FieldWrapper>
  );
};

const CheckBox = (name, ...props) => {

  return (
    <FieldWrapper>
      <label>
        <Field className={styles.checkboxs} type="checkbox" name={name.name} value={name.value} />
        <span className={styles.label}>{name.value}</span>
      </label>
    </FieldWrapper>
  )
}

const ImageUpload = ({
  setFieldValue,
  value,
  label,
  isvolte,
  data,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error ? true : false;
  return (
    <FieldWrapper >
     <div style={{ display: "flex" }}><Label text={label} optional={false} />{label === "Attachment IR21" &&<Asterisk />}</div>
     {!isvolte? 
      <FileAttachment setFieldValue={setFieldValue} name={props.name} value={value} />
      :
      <FileUploadAttachment 
      setFieldValue={setFieldValue} 
      name={props.name} 
      value={value}
      displayMessage={"You can upload one PDF file only, up to 4 MB in size."}
      maxFileSize = {4 * 1024 * 1024} //5MB
      maxFileSizeTXT={"4MB"}
      combineFilesMaxSize={4 * 1024 * 1024}
      combineFilesMaxSizeTXT={"Combined file size exceeds the 4MB limit"}
      numOfFilesAllowToUpload = {1}
      errorMessageForNumberOfFiles ={"You can upload max 1 files."}
      acceptFileType={ {    
        'application/pdf': ['.pdf'],
    }}   
   />}
      {hasError ? <ErrorLabel text={meta.error} /> : null}
    </FieldWrapper>
  );
};
const ButtonWrapper = ({ children }) => {
  return <div className={styles.buttonContainer}>{children}</div>;
};

const NewService = (props) => {
  const { liveServicesData, isLoading } = props;  
  let [isSubmit, setIsSubmit] = useState(false);
  let [isAlert, setIsAlert] = useState(false);
  const [countryDropdown, setCountryDropdown] = useState({});
  const [regionDropdown, setRegionDropdown] = useState({});
  let [defaultActiveTab, setDefaultActiveTab] = useState(SERVICE_REQUEST_OPTIONS.CREATE_NEW);
  const [servicesDropdown, setServicesDropdown] = useState({});
  let [initialValues, setInitialValues] = useState({});
  let [selectedRegion, setSelectedRegion] = useState('');
  let [servicesDetails, setServicesDetails] = useState({});
  let [detailsData, setDetailsData] = useState({});
  let [selectedOrganization, setSelectedOrganization] = useState({});



  const getRegion = (pe_ref) => {
    if (pe_ref) {
      //const obj = props.pops.find(({ hostName }) => hostName.toLowerCase() === pe_ref.toLowerCase());
      const obj =  getLocationDetails(props.pops,pe_ref)
      return obj?.region.value;
    }
  }

  const getLocationName = (pe_ref) => {
    //const obj = props.pops.find(({ hostName }) => hostName.toLowerCase() === pe_ref);
    const obj =  getLocationDetails(props.pops,pe_ref)
    return obj?.city;
  }
  const getCountry = (pe_ref) => {
    //const obj = props.pops.find(({ hostName }) => hostName.toLowerCase() === pe_ref);
    const obj =  getLocationDetails(props.pops,pe_ref)
    return obj?.country;
  }
  const closePopup = () => {    
    props.closeNewServiceForm();
  }

  let _initialValues = {
    organization: props.myRights?.cpName,
    location: "",
    service: "",
    country: "",
    avg_monthly_dtr_volumes: "",
    dns_number: "",
    avg_monthly_msu_volumes: "",
    top_destinations: "",
    checkBox: [],
    allocated_capacity: "",
    comment: "",
    files: [],
    isExistingRoamingPartner:"",
    roamingPartnerName:"",
    roamingPartnerTadigId:"",
    connectivityServiceType:"",
    direction:"",
    requestorTadig:"",
    requestorOrganisationName:"",
    requestorCountry:"",
  };
  let initialdata = {
    organization: props?.initialdata?.organization ,
    service: props?.initialdata?.service,
    country:  props?.initialdata?.locationDetails?.serviceCountry?.label,
    files:props?.initialdata?.files || [],
    isExistingRoamingPartner:props?.initialdata?.service_option?.isExistingRoamingPartner,
    roamingPartnerName:props?.initialdata?.service_option?.roamingPartnerName,
    roamingPartnerTadigId:props?.initialdata?.service_option?.roamingPartnerTadigId,
    connectivityServiceType:props?.initialdata?.service_option?.connectivityServiceType,
    direction:props?.initialdata?.service_option?.direction,
    requestorTadig:props?.initialdata?.service_option?.requestorTadig?.toUpperCase(),
    requestorOrganisationName:props?.initialdata?.service_option?.requestorOrganisationName,
    requestorCountry: props?.initialdata?.service_option?.requestorCountry,
  };

  if (!props.isAmendMode) { // New service form default values    
    _initialValues.organization = props.myRights?.cpName;
    _initialValues.location = "";
    _initialValues.country = "";
    _initialValues.service = "";
    _initialValues.avg_monthly_dtr_volumes = "";
    _initialValues.dns_number = "";
    _initialValues.avg_monthly_msu_volumes = "";
    _initialValues.top_destinations = "";
    _initialValues.checkBox = [];
    _initialValues.allocated_capacity = "";
    _initialValues.comment = "";
    _initialValues.files = [];
    _initialValues.isExistingRoamingPartner="";
    _initialValues.roamingPartnerName="";
    _initialValues.roamingPartnerTadigId="";
    _initialValues.connectivityServiceType="";
    _initialValues.direction="";
    _initialValues.requestorTadig="";
    _initialValues.requestorOrganisationName="";
    _initialValues.requestorCountry="";
  } else {    // Amend service form default values   
    _initialValues.organization = props.myRights?.cpName;
    let service = initialValues?.ipx_service;
    let city = getLocationName(initialValues?.pe_ref);
    let dropDownRegion = getRegion(initialValues?.pe_ref);
    _initialValues.location = dropDownRegion;
    _initialValues.country = getCountry(initialValues?.pe_ref);
    _initialValues.service = service ? service + '-' + city + "-" + initialValues.pe_ref + '~' + initialValues?.ref3c : '';  // Due to duplicate value for dropdown

  }

  const validationSchema = Yup.object({
    organization: Yup.string().required("Required"),
    // location: Yup.string().required("Required"),
     country: Yup.string().required("Required"),
    service: Yup.string().required("Required"),
    location: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService !== VOLTE)
        return schema.required("Required")
      return schema
    }),
    avg_monthly_dtr_volumes: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === DIAMETER)
        return schema.required("Required")

      return schema
    }),
    dns_number: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === DNS)
        return schema.required("Required")
      return schema
    }),
    avg_monthly_msu_volumes: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === SIGTRAN)
        return schema.required("Required")
      return schema
    }),
    top_destinations: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === SIGTRAN)
        return schema.required("Required")
      return schema
    }),
    checkBox: Yup.array().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === SIGTRAN)
        return schema.min(1, "Required")
      return schema
    }),
    allocated_capacity: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if ((selectedService === TRANSPORT) || (selectedService === GRX))
        return schema.required("Required")
      return schema
    }),

    requestorTadig: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === VOLTE)
        return schema.matches(/^[a-zA-Z0-9]{5}$/, "Requestor TADIG Code must be exactly 5 characters long and contain letters and numbers only").required("Required")
      return schema
    }),
    requestorOrganisationName: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === VOLTE)
        return schema.required("Required")
      return schema
    }),
    requestorCountry: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === VOLTE)
        return schema.required("Required")
      return schema
    }),
    roamingPartnerName: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === VOLTE)
        return schema.required("Required")
      return schema
    }),
    roamingPartnerTadigId: Yup.string().when("service", (service, schema) => {
      let selectedService = service?.[0]?.split("-")[0]?.toUpperCase();
      if (selectedService === VOLTE) {
        return schema.matches(/^[a-zA-Z0-9]{5}$/, "Roaming Partner TADIG Code must be exactly 5 characters long and contain letters and numbers only").required("Required")
      }
      return schema;
    }),
    connectivityServiceType: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === VOLTE)
        return schema.required("Required")
      return schema
    }),
    direction: Yup.string().when("service", (service, schema) => {
      let selectedService = (service[0] !== undefined) ? service[0].split("-")[0] : service[0];
      selectedService = (selectedService != undefined) ? selectedService.toUpperCase() : selectedService;
      if (selectedService === VOLTE)
        return schema.required("Required")
      return schema
    }),
    
    comment: Yup.string().max(1000, "Comment must be at most 1000 characters"),
    // files: Yup.array().max(3)
    files: Yup.array().max(3).when("service", (service, schema) => {
      let selectedService =service && service[0] !== undefined ? service[0].split("-")[0] : service[0];
      selectedService =selectedService !== undefined ? selectedService.toUpperCase() : selectedService;
      if (selectedService === VOLTE) {
        return schema
          .required("required").min(1);
      }
      return schema; 
    }),
  
  });

  // function to fetch regionadn country dropdown list

  const getLocationList = () => {
    // console.log("location--->",props.locations,"----region",region)
    let countryData = props.locations?.reduce(function (accObj, currentObj) {
      let regionName = currentObj.region.value + "~" + currentObj.region.label;
      accObj[regionName] = accObj[regionName] || [];
      if (!accObj[regionName].includes(currentObj.country))
        accObj[regionName].push(currentObj.country);
      return accObj;
    }, {});
    let regionDropdown = [];
    let countryDropDown = {};
    countryData && Object.keys(countryData).forEach((key) => {
      let regionObj = {};
      let reg = key.split("~")[0];
      regionObj.value = reg
      regionObj.label = key.split("~")[1];
      regionDropdown.push(regionObj);
      countryDropDown[reg] = [];
      Object.keys(countryData[key]).forEach((country) => {
        let obj = {};
        obj.value = countryData[key][country];
        obj.label = countryData[key][country];
        countryDropDown[reg].push(obj);
      });
    });
    setCountryDropdown(countryDropDown);
    setRegionDropdown(regionDropdown);
  }
  // fetching services dropdown 
  const filterDataByLocation = (liveServiceData, selectedRegion) => {

    if ((props.isAmendMode == true) && (props.myRights?.userType === USER_TYPE.CUSTOMER)) {
      let result = liveServiceData.reduce(function (accObj, currentObj) {
        let region = getRegion(currentObj.pe_ref);
        accObj[region] = accObj[region] || [];
        accObj[region].push(currentObj.ipx_service + "-" + getLocationName(currentObj.pe_ref) + "-" + currentObj.pe_ref+ "~" + currentObj.ref3c + "|" + currentObj.vlan + "|" + currentObj.logical_capacity_mbps + "|" + currentObj.pe_ref + "|" + getRegion(currentObj.pe_ref));
        return accObj;
      }, {});
      let serviceDropDown = {};
      let serviceDetail = {};
      Object.keys(result).forEach((key) => {
        serviceDropDown[key] = [];
        serviceDetail[key] = [];
        Object.keys(result[key]).forEach((service) => {
          let obj = {};
          let serviceLabel = result[key][service].split("~")[0].split("-");
          obj.value = result[key][service].split("|")[0];
          obj.label = serviceLabel[0].toUpperCase() + " (" + serviceLabel[1] + ")";
          obj.detail = result[key][service];
          serviceDropDown[key].push(obj);
          serviceDetail[key].push(obj);
        });
      });
      if (!selectedRegion) {
        let newDropDown = [];
        Object.keys(serviceDropDown).forEach((region) => {
          Object.keys(serviceDropDown[region]).forEach((index) => {
            newDropDown.push(serviceDropDown[region][index])
          });
        });

        const IPXServices= filterIPXLiveServicesForAmend (newDropDown)
        setServicesDropdown(IPXServices);
        setServicesDetails(IPXServices);
      }else{
        const IPXServices= filterIPXLiveServicesForAmend (serviceDropDown[selectedRegion])
        setServicesDetails(IPXServices);
        setServicesDropdown(IPXServices);
      }

    }
  }

  useEffect(() => {
    props.getLocations();

    if (props.myRights?.userType === USER_TYPE.INTERNAL) {
      props.getCustomers();
    }
    props.getServices()

    let searchKey = "";
    let statusFilter = ""
    const orgName = "";
    const service = "";
    let cp_name = props.myRights?.cpName;
    props.getLiveServices(cp_name, searchKey,'',orgName,service,statusFilter) 
  }, [])

  useEffect(() => {
    if(CAN(Action.LIST_COUNTRIES,Resource.DEMANDS)){
      props.getContriesList();
    }
    if(CAN(Action.LIST_ROAMING_PARTNERS,Resource.DEMANDS)){
      props.getRoamingPartnerList();
    }
  }, [])

  useEffect(() => {
    getLocationList();
  }, [props.locations])

  useEffect(() => {
    if (props.isAmendMode == true) {
      // props.setIsAmendMode(true); 
      setDefaultActiveTab(SERVICE_REQUEST_OPTIONS.AMMEND_EXISTING_SERVICE);
      setInitialValues(props.initialValue);
      setSelectedRegion(selectedRegion = getRegion(props.initialValue?.pe_ref));
      filterDataByLocation(liveServicesData, selectedRegion);
      setDetailsData(detailsData = props.initialValue);
    } else {
      // props.setIsAmendMode(false);
      setInitialValues(initialValues = {});
      setSelectedRegion(selectedRegion = '');
      setDefaultActiveTab(SERVICE_REQUEST_OPTIONS.CREATE_NEW);
      // setServicesDropdown(props.services);     
      setDetailsData(detailsData = {});
    }
  }, [props.isAmendMode, props.initialValue])

  const setActiveRadio = (mode) => {
    props.setIsAmendMode(mode);
  }

  const _options = [
    { value: "10 Gbps", label: "10 Gbps" },
    { value: "20 Gbps", label: "20 Gbps" },
    { value: "30 Gbps", label: "30 Gbps" },
    { value: "40 Gbps", label: "40 Gbps" },
    { value: "50 Gbps", label: "50 Gbps" },
    { value: "60 Gbps", label: "60 Gbps" },
    { value: "70 Gbps", label: "70 Gbps" },
    { value: "80 Gbps", label: "80 Gbps" },
    { value: "90 Gbps", label: "90 Gbps" },
    { value: "100 Gbps", label: "100 Gbps" },

  ]
const existingRoamingOption =[
  { value: "true", label: "True" },
  { value: "false", label: "False" },
]
const connectivityServiceType =[
  { value: "2G/3G", label: "2G/3G" },
  { value: "4G", label: "4G" },
]

const directionOption =[
  { value: "Unilateral Inbound", label: "Unilateral Inbound" },
  { value: "Unilateral Outbound", label: "Unilateral Outbound" },
  { value: "Bilateral", label: "Bilateral" },
]


  const navigate = useNavigate();

  const serviceList = () => {
    navigate("/connectivity");
  }

  const closeSidebar = () => {
    props.setIsAmendMode(false);
    props.closeNewServiceForm();
  }

  const [message, setMessage] = useState({
    message: "",
    image: IMAGES.success
  });
  const AmmendServiceDetail = ({ data, city, country, region }) => {
    return (
      <div className={styles.topSection}>
        <div className={styles.topSectionDiv}>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>VLAN ID</div>
            <div className={styles.requestorvalue}>{data?.vlan}</div>
          </div>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Router City</div>
            <div className={styles.servcevalue}>{city}</div>
          </div>
        </div>
        <div className={styles.topSectionDiv}>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Router Name</div>
            <div className={styles.requestorvalue}>{data?.pe_ref}</div>
          </div>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Allocated Capacity (Mbps)</div>
            <div className={styles.servcevalue}>{data?.logical_capacity_mbps}</div>
          </div>
        </div>
        <div className={styles.topSectionDiv}>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Region</div>
            <div className={styles.requestorvalue}>{regionDropdown.find(location => location.value == region)?.label}</div>
          </div>
          <div className={styles.requestorDetailsDiv}>
            <div className={styles.servcelabel}>Country</div>
            <div className={styles.servcevalue}>{country}</div>
          </div>
        </div>
      </div>
    );
  }

  const updateContent = (value) => {
    let selectedServiceDetail = servicesDetails.length
      ? servicesDetails?.find((option) => option.value === value)
      : ""; // mapping with live service id    
    let serviceDetail = selectedServiceDetail.detail.split("~");
    let vlan = serviceDetail ? serviceDetail[1].split("|")[1] : '';
    let capacity = serviceDetail ? serviceDetail[1].split("|")[2] : '';
    let routerName = serviceDetail ? serviceDetail[1].split("|")[3] : '';
    let service = serviceDetail ? serviceDetail[0].split("-")[0] : '';
    let serviceId = serviceDetail ? serviceDetail[1].split("|")[0] : '';
    let region = serviceDetail ? serviceDetail[1].split("|")[4] : '';
    // Updating service Detail data to be shown on pop up for amend service
    let detailData = {};
    detailData.logical_capacity_mbps = capacity ? capacity : '';
    detailData.vlan = vlan ? vlan : '';
    detailData.pe_ref = routerName ? routerName : '';
    detailData.ipx_service = service ? service : '';
    detailData.live_service_id = serviceId ? serviceId : '';
    detailData.organization = props.myRights?.cpName;
    setDetailsData(detailData);
    setSelectedRegion(selectedRegion = getRegion(routerName))
    //_initialValues.country = getCountry(routerName);
  }

  const updateCountryList = (value) => {
    setSelectedRegion(selectedRegion = value);
  }
  const servicesOptions = [...props.services || [], 
 // {value: "VOLTE",label: "VoLTE"}
]; 

const convertedCountries= props?.countries?.data?.map((country) => ({
  value: country.name,
  label: country.name,
}));

const roamingPartnerNames = props?.roamingPartnerName?.map((roamingPartner) => ({
  value: roamingPartner.roamingPartnerName,
  label: roamingPartner.roamingPartnerName,
}));

const [isExistingRomingPartner, setIsExistingRomingPartner] = useState(false);
const [isNewRoamingPartner, setNewRoamingPartner] = useState(false);


const handleContinueClick = (setFieldValue) => {
  setNewRoamingPartner(true);
  setIsExistingRomingPartner(false)
  setFieldValue("roamingPartnerName","");
  setFieldValue("country","")
  setFieldValue("connectivityServiceType","");
  setFieldValue("direction","")
};


const RequestorTadig = props.myRights?.userType===USER_TYPE.CUSTOMER? props?.myRights?.cpName : selectedOrganization?.cpName;
const RequestorOrganisationName = props.myRights?.userType===USER_TYPE.CUSTOMER? props?.myRights?.customerUserMetaInfo?.customerName : selectedOrganization?.displayName;

const ResetFormOnServiceChange = (setFieldValue)=>{
  setFieldValue("roamingPartnerTadigId","");
  setFieldValue("requestorTadig",RequestorTadig);
  setFieldValue("requestorOrganisationName",RequestorOrganisationName);
  setIsExistingRomingPartner(false);
  setNewRoamingPartner(false)   
}
useEffect(()=>{
 if(props?.DetailsForm == "updateVolte"){
   if(props?.initialdata?.service_option?.isExistingRoamingPartner){
    setIsExistingRomingPartner(true);
    setNewRoamingPartner(false)
   }else{
    setIsExistingRomingPartner(false);
    setNewRoamingPartner(true)
   }
 }else{
    setIsExistingRomingPartner(false);
    setNewRoamingPartner(false)
 }
},[props?.DetailsForm,props.isServiceFromOpen])


  return (
    <div>
    <Sidebar
    isOpen={props.isServiceFromOpen}
    onClose={closeSidebar}
    headerTxt={props?.DetailsForm == "updateVolte"
      ? "Update Demand" 
      : (!props.isAmendMode 
          ? "New Demand Form" 
          : "Amend Existing Service Demand Form")}
  >
      <Formik
        initialValues={ props?.DetailsForm == "updateVolte"  ? initialdata :_initialValues}
        enableReinitialize={true}
        validationSchema={validationSchema}
        validateOnChange={true}
        onSubmit={async (values,{ resetForm }) => {
          let obj = {"service_option" : {}, "files": [], "additional_info": {}, "locationDetails":{}};
          obj.organization = values?.organization;  
             
          let service = values?.service;
         // obj.uniqueCustomerRefId = props.myRights.userType===USER_TYPE.CUSTOMER?props.myRights?.customerUserMetaInfo?.uniqueCustomerRefId:selectedOrganization?.uniqueCustomerRefId;

          if (props?.DetailsForm == "updateVolte") {
            obj.uniqueCustomerRefId = props?.initialdata?.uniqueCustomerRefId;
            obj.demandNumberSF = props?.initialdata?.demandNumberSF;
            obj.requestId = props?.initialdata?.requestId;
          } else if (props.myRights.userType===USER_TYPE.CUSTOMER) {
            obj.uniqueCustomerRefId = props.myRights?.customerUserMetaInfo?.uniqueCustomerRefId;
          } else {
            obj.uniqueCustomerRefId = selectedOrganization?.uniqueCustomerRefId;
          }

          if (props.isAmendMode == true) {
            let serviceData = values?.service.split("-");       
            let serviceName = serviceData[0]?serviceData[0].toUpperCase():'';
            service = (serviceName==GRX)?TRANSPORT:serviceName;
          }

          obj.service = service;
         
          let regionLabel = regionDropdown.find(({ value }) => value?.toLowerCase() === values?.location?.toLowerCase())?.label;
          if((service !== VOLTE) ){
          obj.locationDetails.serviceRegion = {'label': regionLabel,'value':values?.location};
          obj.comment = values?.comment;
          }
          obj.locationDetails.serviceCountry = {'label': values?.country,'value':values?.country};
          
          
          if (service === DIAMETER) {
            obj.service_option.avg_monthly_dtr_volumes = values?.avg_monthly_dtr_volumes;
          } else if (service === DNS) {
            obj.service_option.dns_number = values?.dns_number;
          } else if (service === SIGTRAN) {
            obj.service_option.type = values?.checkBox;
            obj.service_option.avg_monthly_msu_volumes = values?.avg_monthly_msu_volumes;
            obj.service_option.top_destinations = values?.top_destinations;
          } else if ((service === TRANSPORT) || (service === GRX)) {
            obj.service_option.allocated_capacity = values?.allocated_capacity;
          }  else if (service === VOLTE){
            obj.service_option.isExistingRoamingPartner = isNewRoamingPartner? false :true;
            obj.service_option.roamingPartnerName = values?.roamingPartnerName;
            obj.service_option.roamingPartnerTadigId = values?.roamingPartnerTadigId;
            obj.service_option.connectivityServiceType = values?.connectivityServiceType;
            obj.service_option.direction = values?.direction;
            obj.service_option.requestorTadig = values?.requestorTadig?.toUpperCase();
            obj.service_option.requestorOrganisationName = values?.requestorOrganisationName;
            obj.service_option.requestorCountry = values?.requestorCountry
          }
                
          if (props?.DetailsForm !== "updateVolte") {
            obj.status = "received";
           }
          obj.files = values?.files;
          if ((props.isAmendMode == true) && (props.myRights?.userType === USER_TYPE.CUSTOMER)) {
            let selectedServiceDetail = servicesDetails.length
            ? servicesDetails?.find((option) => option.value === values.service)
            : ""; // mapping with live service id  
            let serviceDetail = selectedServiceDetail.detail.split("~");          
            let routerName = serviceDetail ? serviceDetail[1].split("|")[3] : '';            
            obj.additional_info.vlan = serviceDetail ? serviceDetail[1].split("|")[1] : '';
            obj.additional_info.physical_capacity_gbps = serviceDetail ? serviceDetail[1].split("|")[2] : '';
            obj.additional_info.pe_ref = routerName;
            obj.additional_info.router_location = getLocationName(routerName);
            obj.additional_info.service_id = serviceDetail ? serviceDetail[1].split("|")[0] : '';
            obj.organization = props.myRights?.cpName;
          }
          setIsSubmit(true);
          if(props?.DetailsForm == "updateVolte"){
            props.SubmitUpdateRequst(obj,props?.initialdata?.id).then((result) => {
              if (result.status) {       
               setIsSubmit(false);  
               resetForm();       
               props.closeNewServiceForm();
               //setIsAlert(true);
               props.openAlertPopup({
                  message: `Service request with ID: ${result?.res?.requestId} has been updated`,
                  image: IMAGES.success
               })
              // props.getServicesList();
              props.getServiceDetail(props?.initialdata?.id);
              }else if(result.code === 500){
                const errormsg = <div>The service is currently unavailable. Please try again later or contact your Vodafone Account Manager for assistance.<div style={{marginTop:'10px'}}></div></div>
                props.showErrorPopup({errorHeader:"Service Unavailable"},{errorMessage:errormsg});
                setIsSubmit(false); 
              }
              else {
                setIsSubmit(false);
                let error_msg = result?.error ??  "An error occurred while processing your request. Please try again later.";
                props.closeNewServiceForm();
                props.openAlertPopup({
                  message: error_msg,
                  image: IMAGES.error
               })
              }
            })
            .catch((error) => {
              setIsSubmit(false);
                    props.openAlertPopup({
                      message: "An error occurred while processing your request. Please try again later.",
                      image: IMAGES.error
                   })
                    props.closeNewServiceForm();
            });
          }else{
            props.submitRequest(obj).then((result) => {
              if (result.status) { 
                // setMessage({
                //   message: `A new service request with ID: ${result.res.requestId} has been created`,
                //   image: IMAGES.success
                // });   
                if(props.serviceActiveTab === MY_SERVICE_TABS.LIVE_SERVICES){
                  props.setServiceActiveTab(MY_SERVICE_TABS.DEMANDS);
                  navigate('/connectivity/demands')
                }          
               setIsSubmit(false);  
               resetForm();   
               props.setIsAmendMode(false);        
               props.closeNewServiceForm();
               //setIsAlert(true);
               props.openAlertPopup({
                  message: `A new demand with ID: ${result.res.requestId} has been created`,
                  image: IMAGES.success
               })
               props.getServicesList();
              } else if(result.code === 500){
                const errormsg = <div>The service is currently unavailable. Please try again later or contact your Vodafone Account Manager for assistance.<div style={{marginTop:'10px'}}></div></div>
                props.showErrorPopup({errorHeader:"Service Unavailable"},{errorMessage:errormsg});
                setIsSubmit(false); 
              }else{
                setIsSubmit(false);
                let error_msg = result?.error ??  "An error occurred while processing your request. Please try again later.";
                props.setIsAmendMode(false);
                props.closeNewServiceForm();
                // setMessage({
                //   message: error_msg,
                //   image: IMAGES.error
                // });
                // setIsAlert(true);
                props.openAlertPopup({
                  message: error_msg,
                  image: IMAGES.error
               })
              }
            })
            .catch((error) => {
              setIsSubmit(false);
             
                    // setMessage({
                    //   message: "Something went wrong.",
                    //   image: IMAGES.error
                    // });
                    // setIsAlert(true);
                    props.openAlertPopup({
                      message: "An error occurred while processing your request. Please try again later.",
                      image: IMAGES.error
                   })
                    props.setIsAmendMode(false);
                    props.closeNewServiceForm();
            });
          }
      

          }}
        >
          {({ isValid, dirty, values, setFieldValue,setValues, setFieldTouched, validateField }) => (
            <Form>
              <div className={`${styles.amendServCont}`}>
              <SectionGuard canAccess={CAN(Action.LIST,Resource.LIVE_SERVICES) && CAN(Action.CREATE,Resource.DEMANDS) && props.myRights?.userType !== USER_TYPE.INTERNAL && props?.DetailsForm !== "updateVolte"}>
               <RadioTabs defaultActiveTab={!props.isAmendMode ? SERVICE_REQUEST_OPTIONS.CREATE_NEW : SERVICE_REQUEST_OPTIONS.AMMEND_EXISTING_SERVICE} options={values?.service===VOLTE?[SERVICE_REQUEST_OPTIONS.CREATE_NEW]:[SERVICE_REQUEST_OPTIONS.CREATE_NEW, SERVICE_REQUEST_OPTIONS.AMMEND_EXISTING_SERVICE]} setActiveRadio={setActiveRadio} />
              </SectionGuard>
              {
                props.myRights?.userType === USER_TYPE.INTERNAL ?
                  <SelectField
                    title={"TADIG Code"}
                    name="organization"
                    isAmendMode={props.isAmendMode}
                    options={sortByLabelAsc(props.organizations?.map((item) => ({ value: item?.cpName, label: item?.cpName }))) || []}
                    onChange={(value) =>{
                      let selectedOrg = props.organizations.find(item => item.cpName === value);
                      setSelectedOrganization(selectedOrg) 
                      setFieldValue("requestorTadig",selectedOrg?.cpName);
                      setFieldValue("requestorOrganisationName",selectedOrg?.displayName);  
                      setFieldTouched("requestorTadig", true);  
                      setTimeout(() => {
                        validateField("requestorTadig"); 
                      }, 0);      
                    }}
                  /> : <></>
              }

              {
                (((props.isAmendMode == true) && (props.myRights?.userType !== USER_TYPE.INTERNAL))) ?
                    <SelectField
                      title={"Search service you want to amend"}
                      name="service"
                      isAmendMode={props.isAmendMode}
                      options={sortByLabelAsc(servicesDropdown)}
                      onChange={(value) => {
                        let selectedService = servicesDetails.length
                          ? servicesDetails?.find((option) => option.value === value)
                          : ""; // mapping with live service id 
                        let serviceDet = selectedService?.detail.split("|");
                        let region = serviceDet[4];
                        let country = getCountry(serviceDet[3]);
                        setFieldValue('location', region);
                        setFieldValue('country', country);
                        //setSelectedRegion(selectedRegion = region); // CUP-2162-Amend service Dropdown not updated on selection. to fix: commented this line as same code present in updateContent function
                        updateContent(value)
                      }}
                    /> :
                  <SelectField
                    title={"Service"}
                    name="service"
                    isAmendMode={props.isAmendMode}
                    options={servicesOptions}
                    onChange={() =>{
                       ResetFormOnServiceChange(setFieldValue);
                       setFieldTouched("requestorTadig", true); 
                       setTimeout(() => {
                        validateField("requestorTadig");
                      }, 0);
                      }}
                    isDisabled={props?.DetailsForm == "updateVolte"}
                  />
              }

              {((props.isAmendMode == true) && values.service && (detailsData.service !== "undefined") && (props.myRights?.userType !== USER_TYPE.INTERNAL)) ?
                <AmmendServiceDetail data={detailsData} city={getLocationName(detailsData.pe_ref)} country={values.country} region={values.location}/> :
                <></>
              }
              {

                (Object.keys(regionDropdown).length == 0) ? <Loader style={styles.btnLoader} /> :
                 props.isAmendMode == false && values?.service && values?.service !== VOLTE && (
                  <SelectField
                  title={"Region"}
                  name="location"
                  isAmendMode={props.isAmendMode}
                  options={regionDropdown}
                  onChange={(value) => {
                    setFieldValue('country', '');
                    updateCountryList(value, setFieldValue)

                  }}
                  // isDisabled={((props.isAmendMode === true) && selectedRegion != "") ? true : false}
                  // customStyles={((props.isAmendMode === true) && selectedRegion != "") ? 'disabledInput' : ''}
                />
                 )
              }
              {props.isAmendMode == false && values?.service && values?.service !== VOLTE &&(
                <SelectField 
                 title={"Country"}
                 name="country"
                 isAmendMode={props.isAmendMode}
                 options={((props.isAmendMode === true) && (props.myRights?.userType === USER_TYPE.CUSTOMER) && (selectedRegion != "")) ?
                 countryDropdown[selectedRegion] : countryDropdown[selectedRegion]}
                 isDisabled={((props.isAmendMode === true) && selectedRegion != "") ? true : false}
                 onChange={(value) => console.log("did it")}
                />
              )}
                 { values?.service && values?.service == VOLTE &&(<>             
              <div className={styles.select}>
               <div className={`${styles.selectwidth} ${styles.dropdownwidths}`}>
              <TextField
                label="Requestor Organisation Name"
                name="requestorOrganisationName"
                type="text"
                placeholder="Requestor Organisation Name"             
               />
              </div>
               <div className={styles.selectwidth}>
              <TextField
                label="Requestor TADIG Code"
                name="requestorTadig"
                type="text"
                placeholder="Requestor TADIG Code"               
               />
                </div>
                </div>
              <SelectField 
              title={"Requestor Country"}
              name="requestorCountry"
              disabled
              isAmendMode={props.isAmendMode}
              options={convertedCountries}
              onChange={(value) => console.log("did it")}
             />
              <CustomSearchInput
                  type="text"
                  name="roamingPartnerTadigId"
                  label="Roaming Partner TADIG Code"
                  placeholder="Roaming Partner TADIG Code"
                  suggestions={ props.roamingPartnerName}
                  onValueChange={(value, isFromSuggestions) => {
                    // Value is string when isFromSuggestions false
                    // Value is object when isFromSuggestions true
                    if(isFromSuggestions){
                      setIsExistingRomingPartner(true)
                      setNewRoamingPartner(false)

                      setValues((prevValues) => ({
                        ...prevValues,
                        roamingPartnerTadigId:value.tadigId,
                        roamingPartnerName: value.roamingPartnerName,
                        country: value.country, 
                      }));
                    }else{
                      setIsExistingRomingPartner(false)
                      setNewRoamingPartner(false)
                      setValues((prevValues) => ({
                        ...prevValues,
                        roamingPartnerTadigId:value,  // value is string when isFromSuggestions false
                        roamingPartnerName: "",
                        country: "", 
                      }));
                    }
                  
                  }} 
              />
               </>)}
               {( !isExistingRomingPartner && values.roamingPartnerTadigId && !isNewRoamingPartner) && (
                 <><div className={styles.continuetxt}><span className={styles.highlight}>TADIG Code not found.</span> Would you like to continue to create new demand with the entered TADIG Code?<span  className={styles.continuebtn}onClick={()=>handleContinueClick(setFieldValue)}> Yes, Continue</span></div></>
                )}
                   
                   {((isExistingRomingPartner)||(isNewRoamingPartner)
                  )  &&(
                      <>
                       <TextField
                        label="Roaming Partner Name"
                        name="roamingPartnerName"
                        type="text"
                        disabled={(isExistingRomingPartner)}
                        autoSelect={true}
                        placeholder="Roaming Partner Name"
                       />

                   {((isExistingRomingPartner))  &&(
                        <TextField                                         
                         label="Country"
                         name="country"
                         type="text"
                         disabled={(isExistingRomingPartner)}
                         placeholder="Country"
                         autoSelect={true}
                        />)}
                   { ((isNewRoamingPartner)) &&(                
                      <SelectField 
                       title={"Country"}
                       name="country"
                       disabled
                       isAmendMode={props.isAmendMode}
                       options={convertedCountries}
                       onChange={(value) => console.log("did it")}
                      />)}
                     <div className={styles.select}>
                      <div className={`${styles.selectwidth} ${styles.dropdownwidths}`}>
                      <SelectField
                       title={"Connectivity Service Type"}
                       name="connectivityServiceType"
                       options={connectivityServiceType}
                       onChange={(value) => console.log("did it")}     
                      />
                      </div>
                      <div className={styles.selectwidth}>
                      <SelectField
                       title={"Direction"}
                       name="direction"
                       options={directionOption}
                       onChange={(value) => console.log("did it")}     
                      />
                     </div>
                    </div>
                     </>
                     )}
              {
                (((props.isAmendMode == true) && (props.myRights?.userType !== USER_TYPE.INTERNAL) && (values?.service?.split("-")[0]?.toUpperCase() == DIAMETER)) || (values?.service === DIAMETER)) ?
                  <TextField
                    label="Avg Monthly DTR Volumes"
                    name="avg_monthly_dtr_volumes"
                    type="text"
                    placeholder="Avg Monthly DTR Volumes"
                  /> : (((props.isAmendMode == true) && (props.myRights?.userType !== USER_TYPE.INTERNAL) && (values?.service?.split("-")[0]?.toUpperCase() == DNS)) || (values?.service === DNS)) ?
                    <TextField
                      label="How Many DNS"
                      name="dns_number"
                      type="number"
                      placeholder="How Many DNS"
                    /> : (((props.isAmendMode == true) && (props.myRights?.userType !== USER_TYPE.INTERNAL) && (values?.service?.split("-")[0]?.toUpperCase() == SIGTRAN)) || (values?.service === SIGTRAN)) ?
                      <React.Fragment>

                        <Label
                          text={"Select Category"}
                        /><Asterisk />
                         <FieldWrapper>
                        <div className={styles.checkboxalign}>
                          <CheckBox
                            name="checkBox"
                            value="On-Net" />
                          <CheckBox
                            name="checkBox"
                            value="Off-Net" />
                          <CheckBox
                            name="checkBox"
                            value="ANSI" />
                        </div>
                        <ErrorMessage name={"checkBox"}>
                          {(msg) => <ErrorLabel text={msg} />}
                        </ErrorMessage>
                      </FieldWrapper>
                      <TextField
                        label="Avg Monthly MSU Volumes"
                        name="avg_monthly_msu_volumes"
                        type="text"
                        placeholder="Avg Monthly MSU Volumes"
                      />
                      <TextField
                        label="Top Destinations"
                        name="top_destinations"
                        type="text"
                        placeholder="Top Destinations"
                      />
                    </React.Fragment> : (((props.isAmendMode == true) && (props.myRights?.userType !== USER_TYPE.INTERNAL) && ((values?.service?.split("-")[0]?.toUpperCase() == TRANSPORT) || (values?.service?.split("-")[0]?.toUpperCase() == GRX))) || ((values?.service === TRANSPORT) || (values?.service === GRX))) ?
                      <SelectField
                        title={"Allocated Capacity"}
                        name="allocated_capacity"
                        options={_options}
                        onChange={(value) => console.log("did it")}     
                      /> : <></>                                       
            }
            {(values.service && values?.service !== VOLTE)?
              <React.Fragment><TextArea
              label={"Additional Information"}
              id="description"
              name="comment"
              maxlength={`${values?.comment?.length}/1000 characters`}
            />
            {/* <div className={styles.commentValidation}>{`${values?.comment?.length}/1000 characters`}</div> */}
            </React.Fragment>:<></>
            
            }
             { ( values.service && values?.service !== VOLTE) ?           
            <ImageUpload
             name="files"
             label="Supporting Attachments"
             value={values.files}
             setFieldValue={setFieldValue}
             optional={false}
            />:<></>}
            {(isExistingRomingPartner) || (isNewRoamingPartner) ?  
            <ImageUpload
             name="files"
             label="Attachment IR21"
             value={values.files}
             setFieldValue={setFieldValue}
             optional={false}
             isvolte={true}
            />:<></>}
            </div>
            <div className={styles.footer}>
           <hr className={styles.separator} />
           <ButtonWrapper>
              <BackButton className={styles.backButton}
                style={styles.submit}
                title={"Back"} closePopup={closePopup} 
              />
              <Submit
                  style={styles.submit}
                  title={"Submit"}
                  isSubmitting={isSubmit}
                  disabled={!isValid || !dirty}
              />
            </ButtonWrapper>
            </div>
          </Form>
        )}
      </Formik>
      </Sidebar>

      {/* {isAlert && (
  <div
    style={{
      zIndex: 20,
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",
    }}
  >    
    <Alert
      image={message.image}
      message={message.message}
      onClose={setIsAlert}
    />
  </div>
)} */}
    </div>
  )
};


export default NewService;
